import { createStore, useStore, StoreApi } from 'zustand';
import { getServerMetrics, getCurrentNetworkTraffic } from '../../api/serverStats/prometheusApi';
import { ServerStatsData } from '../../types/ServerStats';

interface ServerStatsStore {
    serverStats: (ServerStatsData & { net_load_percent?: number }) | null;
    currentNetworkTraffic: {
        download: number;
        upload: number;
        timestamp: number;
    } | null;
    loading: boolean;
    error: string;
    fetchServerStats: () => Promise<void>;
    fetchCurrentNetworkTraffic: () => Promise<void>;
    reset: () => void;
}

const serverStatsStore: StoreApi<ServerStatsStore> = createStore<ServerStatsStore>(() => ({
    serverStats: null,
    currentNetworkTraffic: null,
    loading: false,
    error: '',
    fetchServerStats: async () => {
        const currentState = serverStatsStore.getState();
        serverStatsStore.setState({ loading: true, error: '' });
        try {
            const metrics = await getServerMetrics();
            serverStatsStore.setState({
                serverStats: metrics,
                loading: false,
                error: ''
            });
        } catch (error: any) {
            serverStatsStore.setState({
                serverStats: currentState.serverStats,
                error: error.message || 'Unknown error fetching server stats',
                loading: false
            });
        }
    },
    fetchCurrentNetworkTraffic: async () => {
        const currentState = serverStatsStore.getState();
        try {
            const currentTraffic = await getCurrentNetworkTraffic();
            serverStatsStore.setState({ currentNetworkTraffic: currentTraffic });
        } catch (error: any) {
            console.error('Error fetching current network traffic:', error);
            serverStatsStore.setState({ currentNetworkTraffic: currentState.currentNetworkTraffic });
        }
    },
    reset: () => serverStatsStore.setState({
        serverStats: null,
        currentNetworkTraffic: null,
        loading: false,
        error: ''
    }),
}));

export const useServerStatsStore = <T>(selector: (state: ServerStatsStore) => T): T => useStore(serverStatsStore, selector); 